import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-[100dvh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20tea%20house%20interior%20with%20warm%20golden%20lighting%2C%20steam%20rising%20from%20tea%20cups%2C%20wooden%20shelves%20with%20tea%20jars%2C%20cozy%20ambient%20atmosphere%2C%20soft%20bokeh%20lights%2C%20warm%20cream%20and%20amber%20tones%2C%20cultural%20elegance&width=1920&height=1080&seq=hero-bg-01&orientation=landscape"
          alt="Warm tea house atmosphere"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/65 to-foreground-950/80" />
      </div>

      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto pt-20">
        <p className="text-accent-400 font-label text-sm md:text-base tracking-[0.2em] uppercase mb-4 animate-fade-in">
          A Taste of Tranquility
        </p>
        <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6 animate-fade-up">
          Where Every Cup
          <br />
          <span className="text-accent-400">Tells a Story</span>
        </h1>
        <p className="font-body text-base md:text-lg text-background-200 max-w-xl mx-auto mb-10 leading-relaxed animate-fade-in">
          Experience the art of traditional chai in a warm, welcoming space.
          From our signature Karak blend to premium Afghan green tea, every sip
          is crafted with passion and authenticity.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-up">
          <Link
            to="/menu"
            className="px-8 py-3.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            View Menu
          </Link>
          <Link
            to="/shop"
            className="px-8 py-3.5 bg-background-50/10 backdrop-blur-sm text-background-50 text-sm font-medium rounded-md border border-background-50/30 hover:bg-background-50/20 transition-colors whitespace-nowrap"
          >
            Shop Green Tea
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <button
          onClick={() => {
            const el = document.getElementById('about');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }}
          className="text-background-50/70 hover:text-background-50 transition-colors"
          aria-label="Scroll down"
        >
          <i className="ri-arrow-down-line text-2xl" />
        </button>
      </div>
    </section>
  );
}